{
  "common": {
    "actions": {
      "save": "Enregistrer",
      "edit": "Modifier",
      "saveChanges": "Enregistrer les modifications",
      "saveAndExit": "Enregistrer et quitter",
      "cancel": "Annuler",
      "back": "Retour",
      "delete": "Supprimer",
      "reject": "Rejeter",
      "accept": "Accepter",
      "add": "Ajouter",
      "applyChanges": "Appliquer les modifications",
      "preview": "Aperçu",
      "close": "Fermer",
      "revert": "Rétablir",
      "clickHere": "Cliquez ici",
      "continue": "Continuer",
      "export": "Exporter",
      "learnMore": "En savoir plus",
      "previous": "Précédent",
      "next": "Suivant",
      "complete": "Terminer",
      "change": "Modifier"
    },
    "statuses": {
      "canceled": "Annulé",
      "rejected": "Rejeté",
      "accepted": "Accepté",
      "success": "Succès",
      "failed": "Échec",
      "required": "Requis",
      "open": "Ouvert",
      "closed": "Fermé",
      "imported": "Importé",
      "draft": "Brouillon",
      "forReview": "À réviser",
      "forApproval": "À approuver",
      "approved": "Approuvé",
      "approvalDeclined": "Approbation refusée",
      "effective": "En vigueur",
      "superseded": "Remplacé"
    },
    "labels": {
      "archivedRegistryItem": "{{name}} (Archivé)",
      "deactivatedUser": "{{name}} (Désactivé)",
      "name": "Nom",
      "type": "Type",
      "email": "E-mail",
      "password": "Mot de passe",
      "comments": "Commentaires",
      "properties": "Propriétés",
      "assignedTo": "Assigné à",
      "eventTitle": "Titre de l'événement",
      "eventId": "ID de l'événement",
      "none": "Aucun",
      "reason": "Raison",
      "events": "Événements",
      "created": "Créé",
      "lastModified": "Dernière modification",
      "steps": "Étapes",
      "fields": "Champs",
      "version": "Version",
      "owner": "Propriétaire",
      "eventType": "Type d'événement",
      "eventTypes": "Types d'événement",
      "taskStatus": "Statut de la tâche",
      "createdBetween": "Créé entre",
      "due": "Échéance",
      "status": "Statut",
      "owners": "Propriétaires",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "risk": "Risque",
      "severity": "Gravité",
      "ownerEmail": "E-mail du propriétaire",
      "probability": "Probabilité",
      "product": "Produit",
      "products": "Produits",
      "rootCause": "Cause racine",
      "rootCauses": "Causes racines",
      "relatedRecords": "Relations",
      "source": "Source",
      "assignee": "Responsable",
      "description": "Description",
      "visible": "Visible",
      "required": "Requis",
      "title": "Titre",
      "prefix": "Préfixe",
      "attachments": "Pièces jointes",
      "resolution": "Résolution",
      "relatedTo": "Lié à",
      "approvers": "Approbateurs",
      "reviewers": "Réviseurs",
      "total": "Total",
      "approvalDate": "Date d'approbation",
      "id": "ID",
      "tags": "Tags",
      "emptyProducts": "Produits vides",
      "emptyRootCauses": "Causes racines vides",
      "emptyTags": "Tags vides",
      "emptySeverities": "Gravités vides",
      "emptyProbabilities": "Probabilités vides",
      "suppliers": "Fournisseurs",
      "dueDate": "Date d'échéance",
      "currentDueDate": "Date d'échéance actuelle",
      "newDueDate": "Nouvelle date d'échéance",
      "selectANewOwner": "Sélectionner un nouveau propriétaire",
      "tasks": "Tâches",
      "usersList": "Liste des utilisateurs",
      "createdBefore": "Créé avant",
      "createdAfter": "Créé après",
      "dueAfter": "Échéance après",
      "dueBefore": "Échéance avant",
      "resolvedAfter": "Résolu après",
      "resolvedBefore": "Résolu avant",
      "overdue": "En retard",
      "onTime": "À l'heure",
      "integrationVariables": "Variables d’intégration",
      "comment": "Commentaire",
      "currentOwner": "Propriétaire actuel",
      "newOwner": "Nouveau propriétaire",
      "defaultSections": "Sections par défaut",
      "formSteps": "Étapes du formulaire",
      "capturedIn": "Saisi dans",
      "inSection": "Dans la section",
      "open": "Ouvert",
      "canceled": "Annulé",
      "completed": "Terminé",
      "templateOwner": "Propriétaire du modèle",
      "timeLimitDays": "Limite de temps (jours)",
      "validationStepTimeDelayDays": "Délai du pas de validation (jours)",
      "newTemplateOwner": "Nouveau propriétaire du modèle",
      "defaultContent": "Contenu par défaut",
      "sectionWithPosition": "Section {{position}}",
      "back": "Retour",
      "moveUp": "Monter",
      "moveDown": "Descendre",
      "yes": "Oui",
      "no": "Non",
      "view": "Voir",
      "resolved": "Résolu",
      "closed": "Fermé",
      "imported": "Importé",
      "manage": "Gérer",
      "emptyState": "--",
      "order": "Ordre",
      "fullName": "Nom complet",
      "groups": "Groupes",
      "taskName": "Nom de la tâche",
      "approve": "Approuver",
      "decline": "Refuser",
      "revert": "Rétablir",
      "eventClosed": "Événement fermé",
      "stepCompleted": "Étape terminée",
      "stepReverted": "Étape rétablie",
      "eventReopened": "Événement rouvert",
      "reviewersAssigned": "Réviseurs assignés !",
      "approversAssigned": "Approbateurs assignés !",
      "and": "et",
      "content": "Contenu",
      "form": "Formulaire",
      "validationWithType": "Validation ({{type}})",
      "reopen": "Rouvrir",
      "qualityApproverRequired": "Approbateur qualité requis"
    },
    "placeholders": {
      "email": "E-mail...",
      "password": "Mot de passe...",
      "enterANumber": "Saisir un nombre",
      "writeAComment": "Écrire un commentaire...",
      "searchFor": "Rechercher {{domain}} à ajouter...",
      "noResults": "Aucun résultat",
      "startTypingToSearchFor": "Commencez à taper pour rechercher",
      "newestFirst": "Les plus récents d’abord",
      "oldestFirst": "Les plus anciens d’abord"
    },
    "errors": {
      "defaultErrorMessage": "Un problème est survenu lors de la communication avec le serveur.",
      "timeZoneMissingMessage": "Impossible de trouver le fuseau horaire de l'utilisateur",
      "invalidCredentials": "Identifiants invalides",
      "somethingHasGoneWrong": "Une erreur est survenue !",
      "currentCompanyRoleError": "Impossible de résoudre le rôle de l'utilisateur dans l'instance actuelle",
      "failedToFetchEventDetails": "Échec de la récupération des détails de l'événement",
      "duplicateTitlesNotAllowed": "Les titres en double ne sont pas autorisés. Veuillez utiliser des titres uniques.",
      "invalidCharactersInTitle": "Caractères non valides dans le titre : {{characters}}",
      "missingRequiredFieldsClickHere": "Des champs obligatoires manquent dans l’événement. Cliquez ici pour voir les champs obligatoires de l’événement.",
      "missingRequiredFieldsWithPrefix": "...événement. Cliquez ici pour voir les champs obligatoires de l’événement.",
      "invalidCharactersInTitlePrefix": "Caractères non valides dans le titre :"
    },
    "notifications": {
      "fileReady": "Fichier prêt",
      "preparingFileForDownload": "Préparation du fichier pour le téléchargement",
      "error": "Erreur",
      "userReassigned": "Utilisateur réassigné",
      "eventCreated": "Événement créé",
      "missingInformation": "Informations manquantes",
      "success": "Succès",
      "draftDeleted": "Brouillon supprimé",
      "draftNotDeleted": "Brouillon non supprimé",
      "ownerChanged": "Propriétaire modifié",
      "ownerNotChanged": "Propriétaire non modifié",
      "eventOpened": "Événement ouvert",
      "eventNotOpened": "Événement non ouvert",
      "eventUpdated": "Événement mis à jour",
      "eventNotUpdated": "Événement non mis à jour",
      "taskCompleted": "Tâche terminée",
      "taskNotCompleted": "Tâche non terminée",
      "failed": "Échec",
      "tagsUpdated": "Tags mis à jour",
      "tagsNotUpdated": "Tags non mis à jour",
      "eventPropertiesUpdated": "Propriétés de l'événement mises à jour",
      "newEventCreated": "Nouvel événement créé",
      "eventNotCreated": "Événement non créé",
      "couldNotRetrieveEventMetadata": "Impossible de récupérer les métadonnées",
      "couldNotRetrieveGroups": "Impossible de récupérer les groupes",
      "failedToFetchEventTemplateDetails": "Échec de récupération du modèle d'événement",
      "eventUpdateFailed": "Mise à jour de l'événement échouée",
      "revertedToDraft": "Remis en brouillon",
      "changesSaved": "Modifications enregistrées",
      "failedToUpdateTask": "Échec de la mise à jour de la tâche",
      "couldNotRetrieveTags": "Impossible de récupérer les tags",
      "couldNotRetrieveUsers": "Impossible de récupérer les utilisateurs",
      "reviewed": "Révisé",
      "stepNotReviewed": "Étape non révisée",
      "eventReassignmentFailed": "Échec de réassignation de l'événement",
      "couldNotRetrieveEventTypes": "Impossible de récupérer les types d'événement",
      "failedToFetchFormTemplateDetails": "Échec de récupération du modèle de formulaire",
      "formTemplateUpdateFailed": "Mise à jour du modèle de formulaire échouée",
      "eventTemplateUpdated": "Modèle d'événement mis à jour",
      "eventTemplateNotUpdated": "Modèle d'événement non mis à jour",
      "newDraftCreated": "Nouveau brouillon créé",
      "creatingNewDraftFailed": "Échec de la création du brouillon",
      "templateArchived": "Modèle archivé",
      "templateArchivingFailed": "Échec de l'archivage du modèle",
      "templateRestored": "Modèle restauré",
      "templateRestoringFailed": "Échec de la restauration du modèle",
      "missingRequiredFields": "Champs obligatoires manquants",
      "temporarilyUnableToRetrieveAllEventProperties": "Impossible de récupérer temporairement toutes les propriétés de l’événement",
      "reviewRequest": "Demande de revue",
      "yourReviewIsRequired": "Votre revue est requise",
      "fileReadyToDownloadPrefix": "Le fichier est maintenant disponible pour",
      "fileReadyToDownloadLinkText": "télécharger",
      "couldNotRetrieveSummaryFromAI": "Impossible de récupérer le résumé du service d’IA",
      "propertiesUpdateForEvent": "Mise à jour des propriétés pour l’événement {{eventCode}} réussie",
      "eventCreatedDesc": "\"{{eventCode}} | {{eventTitle}}\" a été créé",
      "eventCreatedWithTitle": "\"{{title}}\" a été créé",
      "tagsUpdatedDesc": "Tags pour {{eventCode}} mis à jour avec succès",
      "eventUpdatedToLatestTemplate": "L’événement a été mis à jour avec le dernier modèle d’événement.",
      "eventNotUpdatedToLatestTemplate": "L’événement n’a pas été mis à jour avec le dernier modèle d’événement.",
      "draftSuccessfullyDeleted": "Le brouillon a été supprimé avec succès",
      "failedToDeleteTheDraft": "Échec de la suppression du brouillon",
      "pleaseSaveTheEventTemplateFirst": "Veuillez d’abord enregistrer le modèle d’événement",
      "wellLetYouKnowWhenFileIsReady": "Nous vous informerons lorsque le fichier sera prêt",
      "exportingEventCodeTitle": "Exportation de {{code}} {{title}}",
      "ownerSuccessfullyChanged": "Propriétaire de {{eventCode}} changé avec succès",
      "theTeamHasBeenNotified": "L’équipe a été informée. Veuillez actualiser la page ou réessayer plus tard."
    },
    "filters": {
      "filterByOwner": "Filtrer par propriétaire...",
      "filterByCollaborator": "Filtrer par collaborateur...",
      "filterByAssignee": "Filtrer par responsable...",
      "filterByCreatedDate": "Filtrer par date de création...",
      "filterByDueDate": "Filtrer par date d'échéance...",
      "filterByResolvedDate": "Filtrer par date de résolution...",
      "filterByDueStatus": "Filtrer par échéance...",
      "filterByProduct": "Filtrer par produit...",
      "filterByRootCause": "Filtrer par cause racine...",
      "filterByTags": "Filtrer par tags...",
      "filterByProbability": "Filtrer par probabilité...",
      "filterByNameEmailOrGroupName": "Filtrer par nom, e-mail ou groupe...",
      "filterBySeverity": "Filtrer par sévérité...",
      "searchRelatedRecords": "Filtrer par relations...",
      "searchMore": "Rechercher plus...",
      "filterByStatus": "Filtrer par statut...",
      "filterByEventType": "Filtrer par type d'événement...",
      "approversAdded": "Approbateurs ajoutés",
      "approversRemoved": "Approbateurs retirés",
      "reviewersAdded": "Réviseurs ajoutés",
      "reviewersRemoved": "Réviseurs retirés",
      "reasonForRemovingTheUserType": "Motif du retrait des {{userType}}..."
    },
    "tables": {
      "noMatchingEventsFound": "Aucun événement trouvé",
      "noMatchingTasksFound": "Aucune tâche trouvée"
    },
    "pagination": {
      "show": "Afficher",
      "showSpace": "Afficher ",
      "previousPage": "page précédente",
      "nextPage": "page suivante"
    },
    "exports": {
      "fileReady": "Fichier prêt",
      "preparingFileForDownload": "Préparation du fichier pour le téléchargement",
      "failedToExportTheFile": "Échec de l'exportation du fichier.",
      "xlsx": "XLSX",
      "pdf": "PDF"
    },
    "units": {
      "days": "jours"
    },
    "debug": {
      "noFlagsReturnedInThisEnvironment": "Aucun indicateur renvoyé dans cet environnement",
      "knownFlags": "Indicateurs connus",
      "rawLDFlagValues": "Valeurs brutes des indicateurs LD"
    }
  },
  "templates": {
    "steps": {
      "dueDays": {
        "header": "Échéance (jours)",
        "tooltip": "Le nombre de jours après la création d'un événement à partir de ce modèle avant que cette étape n'arrive à échéance. Le compte à rebours commence au moment de la création de l'événement.",
        "validation": {
          "range": "Saisissez un nombre entier de jours compris entre 0 et 100000."
        }
      }
    },
    "labels": {
      "eventTemplates": "Modèles d'événements",
      "templateStatus": "Statut du modèle",
      "templateOwner": "Propriétaire du modèle",
      "defaultAssignee": "Responsable par défaut",
      "defaultEventOwner": "Propriétaire par défaut",
      "defaultTimeLimit": "Délai par défaut",
      "validationStepTimeDelay": "Délai de l'étape de validation",
      "timeLimitDays": "Délai (jours)",
      "validationStepTimeDelayDays": "Délai de l'étape de validation (jours)",
      "defaultSections": "Sections par défaut",
      "formSteps": "Étapes du formulaire",
      "inSection": "Dans la section"
    },
    "actions": {
      "editEventTemplate": "Modifier le modèle d'événement",
      "createTemplateDraft": "Créer un brouillon de modèle",
      "makeEffective": "Mettre en vigueur",
      "addStep": "Ajouter une étape",
      "deleteDraft": "Supprimer le brouillon",
      "changeTemplateOwner": "Changer le propriétaire du modèle",
      "createEventTemplate": "Créer un modèle d'événement",
      "renameStep": "Renommer l'étape",
      "changeValidationStepType": "Changer le type d'étape de validation",
      "selectResolution": "Sélectionner la résolution",
      "updateTemplate": "Mettre à jour le modèle",
      "deleteStep": "Supprimer l'étape",
      "createTemplate": "Créer un modèle",
      "addSection": "Ajouter une section",
      "editContentTemplate": "Modifier le modèle de contenu"
    },
    "statuses": {
      "draft": "Borrillon",
      "effective": "En vigueur",
      "archived": "Archivé",
      "forApproval": "À approuver",
      "approvalDeclined": "Approbation refusée",
      "superseded": "Remplacé",
      "allActiveStatuses": "Tous les statuts ouverts"
    },
    "messages": {
      "eventTemplateCreated": "Modèle d’événement créé",
      "templateCreatedWithTitle": "\"{{title}}\" a été créé",
      "eventTemplateCreatedFailTitle": "Modèle d'événement non créé",
      "makeEffectiveSuccessMessage": "Le modèle a été mis en vigueur",
      "eventTemplateUpdateFailTitle": "Modèle non mis à jour",
      "changeEventTemplateOwnerSuccessMessage": "Propriétaire du modèle mis à jour",
      "duplicatedStepNames": "Noms d'étapes en double !",
      "updatesHaveBeenMadeToThisTemplate": "Des mises à jour ont été apportées à ce modèle",
      "pleaseChooseAResolution": "Veuillez choisir une résolution pour les modifications de modèle suivantes. Aucune modification ne sera appliquée au document pour le moment.",
      "aPrefixWillBeAutomaticallyAdded": "Un préfixe sera automatiquement ajouté à chaque événement créé.",
      "eachEventMustBeResolved": "Chaque événement doit être résolu dans le nombre de jours indiqué. C’est une valeur par défaut qui peut être modifiée lors de la création de l’événement.",
      "determinesHowManyDays": "Détermine le nombre de jours nécessaires avant de pouvoir finaliser l’approbation de la dernière étape.",
      "templateSuccessfullyUpdated": "Modèle mis à jour avec succès",
      "failedToUpdateTheTemplate": "Échec de la mise à jour du modèle :",
      "makeThisAResolutionSection": "En faire une section de résolution",
      "contentTemplateNotCreated": "Le modèle de contenu n’a pas été créé",
      "formTemplateNotCreated": "Le modèle de formulaire n’a pas été créé",
      "editContentTemplate": "Modifier le modèle de contenu",
      "editFormTemplate": "Modifier le modèle de formulaire",
      "startBuildingYourForm": "Commencez à créer votre formulaire",
      "makeThisTheValidationStep": "Définir comme étape de validation",
      "onlyOneResolutionSectionAllowed": "Une seule section de type \"Resolution\" est autorisée. Veuillez d’abord changer le type de l’autre section.",
      "resolutionSectionDescription": "Une section de type \"Resolution\" sera présentée comme une case à cocher modifiable pour confirmer si le problème a été résolu ou non.",
      "optionalQualityApproverHelper": "Pour les étapes où l'approbateur qualité est facultatif, au moins un autre approbateur est requis."
    },
    "modals": {
      "makeEffectiveModalHeadingText": "Mettre le modèle en vigueur",
      "makeEffectiveModalSubText": "Saisissez votre signature numérique pour mettre ce modèle en vigueur.",
      "deleteDraftConfirmationHeader": "Supprimer le brouillon ?",
      "deleteDraftConformationBody": "Êtes-vous sûr de vouloir supprimer ce brouillon ? Vos modifications seront perdues.",
      "exportModalTitle": "Exporter l'event template",
      "exportModalSubText": "Qualio exporte les event templates en PDF.",
      "exportCoverPageTitle": "Page de couverture",
      "exportCoverPageSubText": "Une page de couverture inclut les propriétés de l'event template comme première page de l'exportation du template.",
      "exportIncludeCoverPage": "Inclure la page de couverture"
    },
    "fields": {
      "currentEventTemplateOwnerLabel": "Actuel",
      "reasonForChangeInputLabel": "Motif du changement",
      "reasonForChangePlaceholder": "Ajoutez un motif pour la mise en vigueur..."
    },
    "helpText": {
      "templateFieldControlDescription": "Affichez les champs à collecter pour ce type d'événement. Les champs obligatoires seront vérifiés lors de la clôture.",
      "templateFieldControlDescriptionForEventCapture": "Affichez les champs à collecter. Vous pouvez spécifier une étape de formulaire pour capturer le champ.",
      "defaultAssigneeHelper": "Un propriétaire sera assigné automatiquement lors de la création.",
      "defaultEventOwnerHelper": "Un propriétaire par défaut doit être assigné pour créer des événements via intégration.",
      "prefixHelpText": "Un préfixe sera ajouté automatiquement à chaque événement. Lettres et chiffres uniquement.",
      "defaultTimeLimitDefaultHelpText": "Chaque événement doit être résolu dans un délai donné.",
      "defaultTimeLimitEventDueDateHelpText": "L'échéance initiale de l'événement sera calculée selon cette valeur.",
      "validationStepTimeDelayHelpText": "Détermine le nombre de jours avant de pouvoir finaliser l'étape d'approbation."
    },
    "validation": {
      "emptyTitlesAreNotAllowed": "Les titres vides ne sont pas autorisés",
      "duplicateTitlesAreNotAllowed": "Les titres en double ne sont pas autorisés"
    },
    "ckeditor": {
      "insertCodeBlock": "Insérer un bloc de code",
      "insertCodeBlockCaps": "INSÉRER UN BLOC DE CODE",
      "paragraph": "Paragraphe",
      "heading1": "Titre 1",
      "heading2": "Titre 2",
      "heading3": "Titre 3",
      "heading4": "Titre 4",
      "normal": "Normal"
    },
    "content": {
      "resolveSection": "La section '{{sectionTitle}}' est marquée pour suppression, veuillez choisir une résolution."
    }
  },
  "forms": {
    "labels": {
      "fieldTitle": "Titre du champ",
      "helpText": "Texte d'aide",
      "sectionFieldTitle": "Titre de la section",
      "sectionDescription": "Description de la section",
      "defaultContent": "Contenu par défaut",
      "multiSelect": "Sélection multiple",
      "optionSectionLabel": "Options",
      "reviewStep": "Étape de revue"
    },
    "actions": {
      "completeForm": "Remplir le formulaire",
      "addField": "Ajouter un champ",
      "addFormElement": "Ajouter un élément",
      "createNewField": "Créer un champ",
      "chooseQualioResource": "Choisir une ressource Qualio",
      "addHelpText": "Ajouter un texte d'aide",
      "editHelpText": "Modifier le texte d'aide",
      "addSectionDescription": "Ajouter une description",
      "editSectionDescription": "Modifier la description",
      "addDefaultContent": "Ajouter un contenu par défaut",
      "editDefaultContent": "Modifier le contenu",
      "addOption": "Ajouter une option",
      "startBuildingForm": "Commencer à construire le formulaire",
      "editForm": "Modifier le formulaire",
      "sendForReview": "Envoyer pour révision",
      "sendForApproval": "Envoyer pour approbation",
      "reassignStep": "Réassigner l'étape",
      "manageReviewers": "Gérer les réviseurs",
      "manageApprovers": "Gérer les approbateurs",
      "revertToDraft": "Remettre en brouillon",
      "markAsReviewed": "Marquer comme révisé",
      "reassignStepAction": "Réassigner l’étape"
    },
    "messages": {
      "noFormElementAddedYet": "Aucun élément de formulaire n'a encore été ajouté",
      "addFormElementToStartBuilding": "Ajoutez un élément de formulaire pour commencer à créer votre formulaire",
      "formUpdateSuccessTitle": "Valeurs du formulaire mises à jour",
      "formUpdateSuccessMessage": "Formulaire mis à jour avec succès",
      "formUpdateFailedTitle": "Formulaire non mis à jour",
      "formMissingMessage": "Formulaire introuvable",
      "formPreviewWarning": "Ceci est un aperçu du formulaire",
      "formPreviewDuplicateLabelWarning": "Étiquettes en double détectées.",
      "noFormYet": "Aucun formulaire à prévisualiser",
      "startFormCopy": "Commencez à construire votre formulaire pour collecter des données spécifiques.",
      "approversUpdateSuccessTitle": "{{approverType}} mis à jour",
      "approversUpdateSuccessMessage": "{{approverType}} mis à jour avec succès",
      "approversUpdateFailedTitle": "Échec de mise à jour des {{approverType}}",
      "approversUpdateFailedMessage": "Un ou plusieurs {{approverType}} n'ont pas été mis à jour.",
      "atLeastOneAssigneeRequiredMessage": "Un responsable est requis pour ce statut",
      "removingActionedApproverErrorMessage": "Impossible de retirer un {{approverType}} ayant déjà agi",
      "reviewForm": "Réviser « {{formName}} »",
      "disabledDeleteTooltip": "La visibilité est définie dans le modèle.",
      "disableRequiredTooltip": "Le réglage obligatoire est disponible dans le modèle.",
      "pleaseMarkThisStepAsReviewed": "Veuillez marquer cette étape comme révisée",
      "reviewersAdded": "Réviseurs ajoutés"
    },
    "fieldTypes": {
      "text": "Texte sur une ligne",
      "richText": "Paragraphe en texte enrichi",
      "date": "Date",
      "dropdown": "Liste déroulante",
      "boolean": "Oui / Non",
      "numeric": "Numérique",
      "attachment": "Pièce jointe",
      "document": "Document",
      "event": "Événement",
      "supplier": "Fournisseur",
      "user": "Utilisateur",
      "section": "Section",
      "checkbox": "Cases à cocher",
      "radio": "Boutons radio",
      "changeRequest": "Demande de changement",
      "registry": "Registre",
      "designControls": "Contrôles de conception",
      "training": "Formation",
      "documentTemplates": "Modèles",
      "eventTemplates": "Modèles d'événements",
      "task": "Tâche"
    },
    "validation": {
      "optionValueRequired": "Valeur d'option requise",
      "optionValueTooLarge": "La valeur doit faire moins de 512 caractères",
      "optionValueUnique": "Les noms d'options doivent être uniques",
      "requiredFieldHelper": "Ce champ est requis pour clôturer l'événement",
      "formContentInvalidError": "Le contenu du formulaire est invalide",
      "required": "Obligatoire"
    },
    "statusChanges": {
      "sentForReview": "Envoyé pour révision",
      "sentForApproval": "Envoyé pour approbation",
      "revertedToDraft": "Remis en brouillon",
      "cannotSendForReview": "Envoi pour révision impossible",
      "cannotSendForApproval": "Envoi pour approbation impossible",
      "cannotRevertToDraft": "Retour au brouillon impossible",
      "cannotUpdateTheForm": "Mise à jour impossible",
      "wasSentForReview": "{{formTitle}} a été envoyé pour révision",
      "wasSentForApproval": "{{formTitle}} a été envoyé pour approbation",
      "wasRevertedToDraft": "a été remis en brouillon"
    },
    "approvers": {
      "reviewers": "Réviseurs",
      "qualityApprovers": "Approbateurs qualité",
      "otherApprovers": "Autres approbateurs",
      "approverDeclinedStepOnDate": "{{approverName}} a refusé cette étape le {{date}} avec le commentaire suivant :"
    },
    "errors": {
      "cannotSendForApprovalMissingRequiredFields": "Champs obligatoires manquants dans l'événement",
      "pleaseAddApproversBeforeSubmitting": "Veuillez ajouter des approbateurs avant de soumettre.",
      "missingRequiredFieldsOnEvent": "Certains champs obligatoires sont manquants.",
      "toViewTheRequiredEventFields": "pour voir les champs requis."
    }
  },
  "events": {
    "labels": {
      "eventProperties": "Propriétés de l'événement",
      "relatedEvents": "Événements liés",
      "relatedDocuments": "Documents liés",
      "sourceEvent": "Événement source",
      "escalatedTo": "Escaladé vers",
      "relatedSuppliers": "Fournisseurs liés",
      "events": "Événements",
      "tasks": "Tâches",
      "products": "Produits",
      "collaborators": "Collaborateurs"
    },
    "actions": {
      "createEvent": "Créer l'événement",
      "editEvent": "Modifier l'événement",
      "openEvent": "Ouvrir l'événement",
      "cancelEvent": "Annuler l'événement",
      "closeEarly": "Clôture anticipée",
      "updateEvent": "Mettre à jour l'événement",
      "updateTags": "Mettre à jour les tags",
      "escalateAndCreateNewEvent": "Escalader et créer un nouvel événement",
      "exportEvent": "Exporter l’événement",
      "changeOwner": "Changer le propriétaire",
      "changeDueDate": "Modifier la date d'échéance",
      "updateEventProperties": "Mettre à jour les propriétés de l’événement",
      "exportListAsXLSX": "Exporter la liste en XLSX",
      "exportListAsPDF": "Exporter la liste en PDF",
      "approveStep": "Approuver l’étape",
      "declineStep": "Refuser l’étape",
      "reopenEvent": "Rouvrir l’événement",
      "closeEvent": "Fermer l’événement"
    },
    "statuses": {
      "open": "Ouvert",
      "closed": "Clôturé",
      "imported": "Importé",
      "rejected": "Rejeté",
      "canceled": "Annulé"
    },
    "messages": {
      "eventMissingMessage": "Événement introuvable",
      "eventAcceptedMessage": "Événement accepté",
      "eventRejectedMessage": "Événement rejeté",
      "eventCanceledMessage": "Événement annulé",
      "defaultOwnerNoPermissionTitle": "Le propriétaire n'a pas la permission",
      "defaultOwnerNoPermissionMessage": "Droits insuffisants pour le propriétaire",
      "defaultAssigneeNoPermissionTitle": "Le responsable n'a pas la permission",
      "defaultAssigneeNoPermissionMessage": "Droits insuffisants pour le responsable",
      "eventPropertiesNotUpdatedError": "Propriétés non mises à jour",
      "missingRequiredFields": "Champs obligatoires manquants",
      "temporarilyUnableToRetrieveAllEventProperties": "Impossible de récupérer toutes les propriétés actuellement",
      "theTeamHasBeenNotifiedPleaseRefreshOrTryAgainLater": "L'équipe a été prévenue. Veuillez rafraîchir.",
      "theFollowingEventFieldsWillBeCopiedToTheNewEvent": "Les champs suivants seront copiés :",
      "youCanEditEventFieldsAfterCreation": "Vous pourrez modifier les champs après la création.",
      "provideAnyInformationYouHave": "Fournissez toute information dont vous disposez",
      "theFollowingEventFieldsWillBeCopied": "Les champs d’événement suivants seront copiés dans le nouvel événement :",
      "removedFromProperties": "Supprimé des propriétés :",
      "addedToProperties": "Ajouté aux propriétés :",
      "requiredColon": "Obligatoire :",
      "notRequired": "Non obligatoire :",
      "thisActionAffectsStepApprovalStatus": "Cette action affecte le statut d’approbation de l’étape",
      "manageApproverType": "Gérer {{approverType}}",
      "approvalDeclined": "Approbation refusée",
      "manageReviewers": "Gérer les réviseurs",
      "manageQualityApprovers": "Gérer les approbateurs qualité",
      "manageOtherApprovers": "Gérer les autres approbateurs",
      "manageApprovers": "Gérer les approbateurs",
      "selectUsersForReviewerFeedback": "Sélectionnez des utilisateurs pour fournir des commentaires et des suggestions sur le formulaire d’événement.",
      "selectUsersForQualityApproval": "Sélectionnez les utilisateurs requis pour l’approbation finale et la validation du formulaire d’événement.",
      "selectUsersForOtherApproval": "Sélectionnez les utilisateurs responsables de l’approbation finale et de la validation du formulaire d’événement.",
      "selectUsersForApproval": "Sélectionnez les utilisateurs responsables de l’approbation finale et de la validation du formulaire d’événement.",
      "selectProductForEvent": "Sélectionnez le produit associé à cet événement.",
      "selectRootCauseForEvent": "Sélectionnez la cause racine de cet événement.",
      "riskCalculationDescription": "Le risque est calculé à partir des champs de probabilité et de gravité d’un événement. ",
      "linkSuppliersToEvent": "Associez les fournisseurs liés à cet événement. ",
      "canceledOn": "Annulé le",
      "rejectedOn": "Refusé le",
      "closedEarlyOn": "Fermé prématurément le",
      "cancelationReason": "Raison d’annulation",
      "rejectionReason": "Raison du refus",
      "closeReason": "Raison de fermeture",
      "missingQualityTypeApprover": "Approbateur qualité manquant",
      "requiredFieldsMustBeCompletedBeforeApprovalAndClosure": "Les champs obligatoires suivants doivent être renseignés avant que cet événement puisse être approuvé et clôturé :",
      "editEventToFillMissingRequiredFields": "Mettez à jour l'événement pour compléter les champs obligatoires manquants.",
      "removingApproversWarning": "La suppression de ces approbateurs changera l'étape de « à approuver » à « approuvé ».",
      "manageCollaborators": "Gérer les collaborateurs",
      "selectUsersForCollaboration": "Sélectionnez les utilisateurs qui peuvent compléter ou assigner des étapes d’événement, ainsi que créer et gérer des tâches.",
      "collaboratorsAdded": "Collaborateurs ajoutés",
      "collaboratorsRemoved": "Collaborateurs retirés"
    },
    "modals": {
      "eventAcceptSubText": "Saisissez votre signature numérique pour accepter",
      "eventCancelSubText": "Cette action annulera toutes les étapes.",
      "eventRejectSubText": "Saisissez votre signature numérique pour rejeter",
      "approveStepSubText": "Saisissez votre signature numérique pour approuver l’étape",
      "declineStepSubText": "Saisissez votre signature numérique pour refuser l’étape",
      "closeEarlySubText": "Cette action annulera toutes les étapes de l’événement et marquera l’événement comme fermé.",
      "reopenEventSubText": "Êtes-vous sûr de vouloir rouvrir cet événement ?",
      "eventSuccessfullyClosed": "Événement {{eventCode}} fermé avec succès",
      "eventSuccessfullyReopened": "Événement {{eventCode}} rouvert avec succès",
      "changeDueDateReasonPlaceholder": "Ajoutez un motif pour modifier la date d'échéance...",
      "dueDateSuccessfullyUpdated": "Date d'échéance mise à jour avec succès",
      "collaboratorsSuccessfullyUpdated": "Collaborateurs mis à jour avec succès"
    },
    "create": {
      "provideRequiredInformationToCreateAnEvent": "Fournissez les informations requises pour créer l'événement."
    },
    "tabs": {
      "details": "Détails"
    }
  },
  "tasks": {
    "labels": {
      "taskStatus": "Statut de la tâche",
      "assignTo": "Assigner à",
      "reassignTo": "Réassigner à"
    },
    "actions": {
      "createTask": "Créer une tâche",
      "completeTask": "Terminer la tâche",
      "reopenTask": "Rouvrir la tâche",
      "completeStep": "Terminer l'étape",
      "actionStep": "Étape d'action",
      "revertStep": "Rétablir l’étape",
      "revertStepCompletion": "Annuler la finalisation de l’étape ?",
      "assignStep": "Assigner l’étape",
      "reassign": "Réassigner",
      "assign": "Assigner",
      "comment": "Commenter"
    },
    "modals": {
      "signOffToRevertCompletion": "Signer pour annuler la finalisation de l’étape \"{{stepLabel}}\"",
      "stepCompletionWasReverted": "La finalisation de l’étape \"{{stepLabel}}\" a été annulée",
      "signOffToCompleteStep": "Signer pour terminer l’étape \"{{stepLabel}}\"",
      "stepWasMarkedComplete": "L’étape \"{{stepLabel}}\" a été marquée comme terminée"
    },
    "messages": {
      "userReassigned": "Utilisateur réassigné",
      "userReassignedSuccessfully": "Utilisateur réassigné avec succès.",
      "completeFormAndSendForReview": "Complétez le formulaire et envoyez‑le pour revue et approbation lorsqu’il est prêt.",
      "noFormAssociatedWithStep": "Aucun formulaire n’est associé à cette étape.",
      "thisFieldRequiredBeforeClosing": "Ce champ est requis avant de fermer l’événement.",
      "cannotSendForApprovalUntil": "Cette résolution ne peut pas être envoyée pour approbation avant",
      "createAndAssignTasks": "Créez et assignez des tâches et suivez leur progression.",
      "noTasksAssociatedWithStep": "Aucune tâche n'est associée à cette étape."
    }
  },
  "products": {
    "confirmations": {
      "deleteProductConfirmation": "Voulez-vous vraiment supprimer « {{productName}} » ?"
    }
  },
  "rootCauses": {
    "labels": {
      "rootCauses": "Causes racines"
    },
    "confirmations": {
      "deleteRootCauseConfirmation": "Voulez-vous vraiment supprimer la cause racine « {{rootCauseName}} » ?"
    }
  },
  "search": {
    "errors": {
      "searchFailed": "Échec de la récupération des résultats"
    }
  }
}
